import { render, staticRenderFns } from "./EsgChart.vue?vue&type=template&id=4b3988ae&scoped=true"
import script from "./EsgChart.vue?vue&type=script&lang=js"
export * from "./EsgChart.vue?vue&type=script&lang=js"
import style0 from "./EsgChart.vue?vue&type=style&index=0&id=4b3988ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3988ae",
  null
  
)

export default component.exports